import {
  Control,
  useController,
  RegisterOptions,
  ControllerRenderProps,
  ControllerFieldState,
  UseFormStateReturn,
} from "react-hook-form";

function Field({
  control,
  label,
  name,
  rules,
  render,
  inputProps,
  errorMessage,
  shouldUnregister,
}: {
  control: Control<any, object>;
  rules?: Omit<
    RegisterOptions<any, any>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
  label?: string;
  name: string;
  render?: ({
    field,
    fieldState,
    formState,
    isInvalid,
  }: {
    field: ControllerRenderProps<any, any>;
    fieldState: ControllerFieldState;
    formState: UseFormStateReturn<any>;
    isInvalid?: boolean;
  }) => React.ReactElement;
  inputProps?: any;
  errorMessage?: string;
  shouldUnregister?: boolean;
}) {
  const { field, fieldState, formState } = useController({
    name,
    control,
    rules,
    defaultValue: "",
    shouldUnregister,
  });

  let { invalid, error } = fieldState;

  invalid = invalid || !!errorMessage;

  return (
    <div>
      {label ? (
        <div>
          {label}
          {rules?.required ? "*" : ""}
        </div>
      ) : null}

      {typeof render !== "function" ? (
        <input
          className={`input-login-style`}
          {...field}
          {...inputProps}
          isInvalid={invalid}
        />
      ) : null}

      {typeof render === "function"
        ? render({ field, fieldState, formState, isInvalid: invalid })
        : null}

      {invalid ? (
        <div className="mt-[-1.25rem] text-error">{error?.message || errorMessage || "Campo obrigatório"}</div>
      ) : null}
    </div>
  );
}

export default Field;
